import React, { Fragment, useEffect, useState } from "react";
import { OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Tooltip from 'react-bootstrap/Tooltip';
import Multiselect from "multiselect-react-dropdown";
import { getApi } from "../../api/endpoints";
import { toast } from "react-toastify";
import ToggleSwitch from "../../components/ToggleSwitch";

const MerchantOfferConfig = (props) => {
  const { offerObj, setOffer, branches } = props;
  const [getMerchantsApi] = getApi('merchants');
  const [merchants, setMerchants] = useState([]);
  const [merchantOptionsState, setMerchantOptionsState] = useState({});
  const [currentBranchId, setCurrentBranchId] = useState(null);
  const [originalBranchConfigs, setOriginalBranchConfigs] = useState({});


  useEffect(() => {
    getMerchantsOptions();
  }, [])

  useEffect(() => {
    const updatedMerchantOptions = {};
    offerObj.branch_offer_configs.forEach((config) => {
      const selectedMerchants = config.config.merchant_configs ? config.config.merchant_configs.map(item => item.id) : [];
      const availableMerchants = merchants.filter(
        (merchant) => !selectedMerchants.includes(merchant.id)
      );
      updatedMerchantOptions[config.branch_id] = availableMerchants;
    });
    setMerchantOptionsState(updatedMerchantOptions);
    offerObj.validate('branch_offer_configs');
  }, [offerObj.branch_offer_configs, merchants]);

  const getMerchantsOptions = async () => {
    try{
      let response = await getMerchantsApi({ fields: 'options' }).unwrap();
      setMerchants(response?.data?.merchants.map(item => {
        return {...item, displayValue : item.name + ' - ' + item.gateway}
      }));
    } catch(error){
      toast.error(error?.data?.message || 'Something went wrong while fetching merchants.')
    }
  }

  const dynamicValueChange = (event, currentIndex, branch_id) => {
    event.preventDefault();
    const { id, value } = event.target;
    setOffer((prevState) => {
      const updatedState = { ...prevState };
      updatedState.branch_offer_configs = prevState.branch_offer_configs.map((branchConfig) => {
        if (branchConfig.branch_id === branch_id) {
          const updatedMerchantConfigs = branchConfig.config.merchant_configs.map((config, index) => {
            if (currentIndex === index) {
              return { ...config, [id]: value };
            }
            return config;
          });
  
          return {
            ...branchConfig,
            config:{
              ...branchConfig.config,
              merchant_configs: updatedMerchantConfigs,
            }
          };
        }
        return branchConfig;
      });
  
      return updatedState;
    });
  };

  const onMerchantSelect = (selectedItem, currentIndex, branch_id) => {
    setOffer((prevState) => {
      const updatedState = { ...prevState };
      updatedState.branch_offer_configs = prevState.branch_offer_configs.map((branchConfig) => {
        if (branchConfig.branch_id === branch_id) {
          const updatedMerchantConfigs = branchConfig.config.merchant_configs.map((config, index) => {
            if (currentIndex === index) {
              return { ...config, id: selectedItem.id };
            }
            return config;
          });
  
          return {
            ...branchConfig,
            config: {
              ...branchConfig.config,
              merchant_configs: updatedMerchantConfigs,
            },
          };
        }
        return branchConfig;
      });
  
      return updatedState;
    });
  };
  
  const onMerchantRemove = (removedItem, currentIndex, branch_id) => {
    setOffer((prevState) => {
      const updatedState = { ...prevState };
      updatedState.branch_offer_configs = prevState.branch_offer_configs.map((branchConfig) => {
        if (branchConfig.branch_id === branch_id) {
          const updatedMerchantConfigs = branchConfig.config.merchant_configs.map((config, index) => {
            if (currentIndex === index) {
              return { ...config, id: "" };
            }
            return config;
          });
  
          return {
            ...branchConfig,
            config: {
              ...branchConfig.config,
              merchant_configs: updatedMerchantConfigs,
            },
          };
        }
        return branchConfig;
      });
  
      return updatedState;
    });
  }

  const handleAddDynamicFields = (event, branch_id) => {
    event.preventDefault();
    setOffer((prevState) => {
      const updatedState = { ...prevState };
      updatedState.branch_offer_configs = prevState.branch_offer_configs.map((branchConfig) => {
        if (branchConfig.branch_id === branch_id) {
          const updatedMerchantConfigs = branchConfig.config.merchant_configs
            ? [...branchConfig.config.merchant_configs]
            : [];
          updatedMerchantConfigs.push({
            id: '',
            recharge_cashback_percentage: '',
            recharge_amount_threshold: '',
          });
          return {
            ...branchConfig,
            config:{
              ...branchConfig.config,
              merchant_configs: updatedMerchantConfigs,
            }
          };
        }
        return branchConfig;
      });
      return updatedState;
    });
  };

  const handleRemoveDynamicFields = (event, removedIndex, branch_id) => {
    event.preventDefault();
    setOffer((prevState) => {
      const updatedState = { ...prevState };
      updatedState.branch_offer_configs = prevState.branch_offer_configs.map((branchConfig) => {
        if (branchConfig.branch_id === branch_id) {
          const updatedMerchantConfigs = branchConfig.config.merchant_configs.filter(
            (config, index) => index !== removedIndex
          );
          return {
            ...branchConfig,
            config: {
              ...branchConfig.config,
              merchant_configs: updatedMerchantConfigs,
            },
          };
        }
        return branchConfig;
      });

      return updatedState;
    });
  }

  // const onApplyForAll = (branch_id) => {
  //   if(currentBranchId !== null){
  //     // window.location.reload();
  //   }
  //   setCurrentBranchId((prev) => (prev === branch_id ? null : branch_id));
  //   setOffer((prevState) => {
  //     if (currentBranchId === branch_id) {
  //       return prevState;
  //     }
  //     const updatedState = { ...prevState };
  //     const selectedBranchConfig = prevState.branch_offer_configs.find(
  //       (config) => config.branch_id === branch_id
  //     );
  //     updatedState.branch_offer_configs = prevState.branch_offer_configs.map((branchConfig) => ({
  //       ...branchConfig,
  //       config: {
  //         ...branchConfig.config,
  //         merchant_configs: [...(selectedBranchConfig?.config.merchant_configs || [])],
  //       },
  //     }));
  //     return updatedState;
  //   });
  // };

  const onApplyForAll = (branch_id) => {
    setCurrentBranchId((prev) => (prev === branch_id ? null : branch_id));
    setOffer((prevState) => {
      if (currentBranchId === branch_id) {
        const updatedState = { ...prevState };
        updatedState.branch_offer_configs = prevState.branch_offer_configs.map((branchConfig) => ({
          ...branchConfig,
          config: {
            ...branchConfig.config,
            merchant_configs: originalBranchConfigs[branchConfig.branch_id] || branchConfig.config.merchant_configs,
          },
        }));
        return updatedState;
      }
      setOriginalBranchConfigs((prevOriginal) => {
        const newOriginal = { ...prevOriginal };
        prevState.branch_offer_configs.forEach((branchConfig) => {
          newOriginal[branchConfig.branch_id] = [...(branchConfig.config.merchant_configs || [])];
        });
        return newOriginal;
      });
      const updatedState = { ...prevState };
      const selectedBranchConfig = prevState.branch_offer_configs.find(
        (config) => config.branch_id === branch_id
      );
      updatedState.branch_offer_configs = prevState.branch_offer_configs.map((branchConfig) => ({
        ...branchConfig,
        config: {
          ...branchConfig.config,
          merchant_configs: [...(selectedBranchConfig?.config.merchant_configs || [])],
        },
      }));
      return updatedState;
    });
  };

  return <Fragment>
    <div className='mt-5'>
      <div className='d-flex'>
        <h6 className='text-success'>Merchant Cashback Configuration</h6>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400}}
          overlay={(props) =>
            <Tooltip id="field-ifo-tooltip" {...props} style={{ ...props.style, fontSize: "14px" }}>
              <strong>Merchant offer cashback configuration.</strong>
            </Tooltip>
          }
        >
          <FontAwesomeIcon
            className="icon ms-2"
            icon={faInfoCircle}
            style={{ cursor: 'pointer', color: 'green', width: '15px', height: '15px', paddingTop: '2px' }}
          />
        </OverlayTrigger>
      </div>
      <div id="recharge_cashback_percentage_help" className="form-text text-danger mt-0">
        {offerObj.errors.branch_offer_configs}
      </div>
    </div>
    {
      offerObj.branch_offer_configs && offerObj.branch_offer_configs.length > 0 && offerObj.branch_offer_configs.map((config, idx) =>
        <Fragment key={idx}>
          
          <div className="border rounded bg-light my-4 p-2">
            <div className="d-flex align-items-center my-3">
              <div className="me-auto d-flex align-items-center">
                <h6 className="text-secondary">
                  Branch: <span className="fw-bold">{branches.find(branch => branch.id === config.branch_id)?.name}</span>
                </h6>
                {
                  currentBranchId === config.branch_id &&
                  <div className="mx-4" style={{backgroundColor: '#FFDB9B', color: '#CE8501', padding: '5px 10px'}}>
                    <FontAwesomeIcon
                      className="mx-1"
                      icon={faInfoCircle}
                      style={{ width: '15px', height: '15px' }}
                    />
                    This configuration will be applied to all the branches for this offer. To change it, turn off 'Apply for all branches'.
                  </div>
                }
              </div>
              <div className="mx-2 pt-1">
                <label htmlFor='merchant_config_for_all_branches' className="text-secondary">Apply for all branches</label>
              </div>
              <div className="d-inline-flex">
                <ToggleSwitch
                  id={`apply_for_all_${config.branch_id}`}
                  onChange={(e) => onApplyForAll(config.branch_id)}
                  checked={currentBranchId === config.branch_id}
                  label_left=""
                  label_right =""
                  className="form-control"
                />
              </div>
            </div>
          {
            (config.config.merchant_configs && config.config.merchant_configs.length > 0) &&
            ((currentBranchId === null || currentBranchId === config.branch_id) ? (config.config.merchant_configs.map((item, index) => {
              return <Fragment key={index}>
                <div className="row">
                  <div className="col-md-3 my-2">
                    <label htmlFor="id" className="form-label mb-1">Select Merchant</label>
                    <Multiselect
                      id={'id'}
                      selectedValues={merchants.filter(i => i.id === item.id)}
                      options={merchantOptionsState[config.branch_id] || []}
                      onSelect={(selectedList, selectedItem) => onMerchantSelect(selectedItem, index, config.branch_id)}
                      onRemove={(removedList, removedItem) => onMerchantRemove(removedItem, index, config.branch_id)}
                      selectionLimit={1}
                      displayValue="displayValue"
                      showArrow={true}
                      customArrow={true}
                      avoidHighlightFirstOption={true}
                      disable={currentBranchId === config.branch_id}
                    />
                  </div>
                  <div className="col-md-4 my-2">
                    <label htmlFor="recharge_cashback_percentage" className="form-label mb-1">Cashback Percentage %</label>
                    <input
                      id="recharge_cashback_percentage"
                      value={!item.recharge_cashback_percentage || item.recharge_cashback_percentage !== null ? item.recharge_cashback_percentage : ''}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value);
                        if (value > 100) {
                          e.target.value = 100;
                        }
                        dynamicValueChange(e, index, config.branch_id);
                      }}
                      type="number"
                      min={0}
                      max={100}
                      step={0.1}
                      onKeyDown={(e) => {
                        if (e.code === 'Minus') {
                          e.preventDefault();
                        }
                      }}
                      className="form-control form-control-sm font-size-12"
                      placeholder='Enter Recharge Cashback Percentage'
                      aria-describedby="recharge_cashback_percentage_help"
                      disabled={currentBranchId === config.branch_id}
                    />
                  </div>
                  <div className="col-md-4 my-2">
                    <label htmlFor="recharge_amount_threshold" className="form-label mb-1">Cashback Threshold</label>
                    <input
                      id="recharge_amount_threshold"
                      value={!item.recharge_amount_threshold || item.recharge_amount_threshold !== null? item.recharge_amount_threshold : ''}
                      onKeyDown={(e) => { if (e.code === 'Minus') e.preventDefault(); }}
                      onChange={(e) => dynamicValueChange(e, index, config.branch_id)}
                      type="number"
                      className="form-control form-control-sm font-size-12"
                      placeholder='Enter Recharge Amount Threshold'
                      aria-describedby="recharge_amount_threshold_help"
                      disabled={currentBranchId === config.branch_id}
                    />
                  </div>
                  {
                    <div className="col-md-1 d-flex justify-content-center align-items-center">
                      <button
                        onClick={(e) => handleRemoveDynamicFields(e, index, config.branch_id)}
                        className="remove-button"
                        type='button'
                        style={{ fontSize: '12px', height: '30px' }}
                        disabled={currentBranchId === config.branch_id}
                      >
                        <span>
                          <FontAwesomeIcon icon={faCircleXmark} className="me-2" />
                        </span>
                        Remove
                      </button>
                    </div>
                  }
                </div>
              </Fragment>}
            )) : (
              <p className="text-secondary">
                Branch <span className="fw-bold">{branches.find(branch => branch.id === currentBranchId)?.name}</span>'s Merchant Cashback Configurations will be applied to this branch.
              </p>
            ))
          }
          {
            (!config.config.merchant_configs || merchants.length !== config.config.merchant_configs.length) &&
            <button
              onClick={(event) => handleAddDynamicFields(event, config.branch_id, idx)}
              className="add-button my-2 me-2"
              type='button'
              disabled={(currentBranchId !== null && currentBranchId !== config.branch_id) ? true : config.config.merchant_configs ?
                (currentBranchId === config.branch_id) ? true :
                config.config.merchant_configs.map(config =>
                  config.id !== "" && config.recharge_cashback_percentage !== "" && config.recharge_amount_threshold !== "").includes(false) :
                false
              }
              style={{ padding: '6px' }}
            >
              Add New Merchant Configuration
            </button>
          }
          </div>
        </Fragment>
      )
    }
  </Fragment>
}

export default MerchantOfferConfig;
